export const info = [
        {
          id: 1,
          carrera: "Administración",
          descp: "El alumno que pertenezca a la carrera de administracion, debera contar con los conocimientos de basicos de las siguientes areas poseer conocimientos en matematicas, contabilidad, estadistica, administracion y informatica trabajar en equipo y tener facilidad para adaptarse a diferentes entorno ser comprometido honesto y ser proactivo en el trabajo de equipo.",
          imagenUrl: "https://www.cessuniversidad.com/assets/images/LIC%20ADMIN.jpg"

        },
        {
          id: 2,
          carrera: "Licenciatura en Educación",
          descp: "El perfil de ingreso debera tener las siguientes habilidades manejo de lenguaje oral y escrito, el manejo de paqueteria de microsoft office,lectura a nivel de comprension, actitud de colaboracion,capacidad para atender problemas educativos,iniciativa para integrar propuestas de desarrollo comunitario y social valores de compromiso social y respeto a las condiciones socioculturales, asi como el compromiso permanente con la formacion academica.",
          imagenUrl: "https://www.cessuniversidad.com/assets/images/LIC%20EDUCACION.jpg"

        },
        {
          id: 3,
          carrera: "Criminología",
          descp: "Capacidad de expresar ideas y conceptos mediante representacion linguisticas matematicas o graficas aplicar las distintas estrategias comunicativas segun sus interlocutores,el contexto en el que se encuentra y los objetivos que persigue identificar problemas,formular preguntas de caracter cientifico y plantear hipotesis necesarias para responderlas construir hipotesis,diseñar y aplicar modelos para probar su validez.",
          imagenUrl: "https://www.cessuniversidad.com/assets/images/LIC%20CRIMINOLOGIA.jpg"

        },
        {
          id: 4,
          carrera: "Arquitectura",
          descp: "El alumno que pertenezca a la carrera de arquitectura,debera contar con los conocimientos de basicos de las siguientes areas fisico-matematico historia de la cultura y el arte Dibujo Computacion Asi como presentar habilidades de: comunicacion grafica, oral y escrita habilidad para el trabajo manual hapacidad de analisis y sintesis apertura hacia la innovacion y el cambio mostrar interes vocacional hacia la arquitectura",
          imagenUrl: "https://www.cessuniversidad.com/assets/images/LIC%20ARQUITECTURA.jpg"

        },
        {
          id: 5,
          carrera: "Derecho",
          descp: "El perfil de ingreso debera tener las siguientes habilidades,razonamiento logico y critico, comunicacion oral y escrita, autoaprendizaje,lectura comprensiva,respeto a la dignidad humana, interes por los derechos humanos, manejo basico de las tecnologias de la informacion disposicion para el trabajo interdisciplinario y conocimiento sobre el impacto del derecho en la sociedad.",
          imagenUrl: "https://www.cessuniversidad.com/assets/images/LIC%20DERECHO.jpg"

        }
      ];